if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false,
        arrows: true,
        fade: true,
    });

    $('.gallery-block__left').slick({
        accessibility: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        fade: true,
    });


    $('.gallery_left_small_slider').slick({
        accessibility: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        fade: false,
        asNavFor: '.slider-secondary',

    });

    $('.gallery_left_big_slider').slick({
        accessibility: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        fade: false,
    });


    $('.gallery_right_big_slider').slick({
        accessibility: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        fade: false,
    });

    $('.gallery_right_small_slider').slick({
        accessibility: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        fade: false,
    });

    //BURGER MENU FUNCTIONALITY
    const BURGER = document.querySelectorAll('.js-burger-menu');
    const NAVIGATION = document.querySelector('.js-navigation');
    const CLOSEBTN = document.querySelector('.js-close-btn');
    
    BURGER.forEach(cta => {
        cta.addEventListener('click', function() {
            NAVIGATION.classList.add('is-active');
        });
    })
   

    CLOSEBTN.addEventListener('click', function() {
        NAVIGATION.classList.remove('is-active');
    });
    //END BURGER MENU FUNCTIONALITY


    //FORMS LABELS ANIMATION
    function getInputs( form ) {

        let fields;

        form.querySelector('.form-module__field')
            ? fields = form.querySelectorAll('.form-module__field input , .form-module__field textarea')
            : fields = form.querySelectorAll('.field input, .field textarea');

        return fields
    }

    function toggleActiveClass( fieldsColection ) {
        fieldsColection.forEach( function(field) {
            field.addEventListener('focus', function() {
                let fieldParent = this.parentNode;
                fieldParent.classList.add('is-active');
            });
            field.addEventListener('blur', function() {
                let fieldParent = this.parentNode;
                if(this.value === '') {
                    fieldParent.classList.remove('is-active');
                }
            });
        });
    }

    if(document.querySelector('.form-module')) {
        let fieldsColection = getInputs( document.querySelector('.form-module') );
        toggleActiveClass( fieldsColection );
    }

    if(document.getElementById('email-signup')) {
        let fieldsColection = getInputs( document.getElementById('email-signup') );
        // console.log(fieldsColection);
        toggleActiveClass( fieldsColection );
    }
    //END FORMS LABELS ANIMATION


    //MENUS FUNCTIONALITY
    if(document.querySelector('.menus-block')){
        
        function wrapTextWithSpan(text, searchText) {
            const regex = new RegExp(searchText, 'gi'); // 'gi' is used to make the search case insensitive
            const result = text.replace(regex, match => `<span class="special-ingredient">${match}</span>`);

            return result;
        }

        function hiddeMenus( menu ){
            !menu.classList.contains('hidden')
                ? menu.classList.add('hidden')
                : null;
        }

        function getCategoryID( category ) {
            let categoryID = category.getAttribute('data-category');
            let categoryTarget = document.querySelector(`.js-menu[data-category="${categoryID}"]`);

            return {
                categoryID,
                categoryTarget
            }
        }

        function firstLoad( CATEGORIES ) {
            CATEGORIES[0].click();
        }

        const CATEGORIES = document.querySelectorAll('.js-category');
        const MENUS = document.querySelectorAll('.js-menu');
        const DESCRIPTIONS = document.querySelectorAll('.product__desc p');
        const INGREDIENTSBOXES = document.querySelectorAll('.ingredient-box');

        let ingredientsLabels = [];
        let contentText

        CATEGORIES.forEach(( category ) => {


            category.addEventListener('click', function() {

                CATEGORIES.forEach(( category ) => {
                    category.classList.remove('is-active');
                });

                let { categoryID, categoryTarget } = getCategoryID( this );

                this.classList.add('is-active');

                MENUS.forEach(( menu ) => {
                    hiddeMenus( menu );

                    menu.dataset.category === categoryID
                        ? menu.classList.remove('hidden')
                        : null;
                });

            });

        });

       firstLoad( CATEGORIES );



        //Do the ingredients lighboxes
        DESCRIPTIONS.forEach(( description ) => {
            contentText = description.innerText;

            INGREDIENTSBOXES.forEach(( ingredientBox ) => {
                let ingredient  = ingredientBox.dataset.ingredient
                contentText = wrapTextWithSpan(contentText, ingredient); // get the text from the description and wrap the ingredients with a span
                description.innerHTML = contentText;// put the text back in the description
            });
        })

        function searchBox( boxes, ingredient ) {

            let myBox;

            boxes.forEach(( box ) => {

                if(box.dataset.ingredient === ingredient) {
                    myBox = box;
                }
            });

            return myBox;
        }


        if(document.querySelector('.special-ingredient')) {
            let specialIngredients = document.querySelectorAll('.special-ingredient');

            specialIngredients.forEach(( ingredient ) => {
                ingredient.addEventListener('mouseover', () => {
                    let myBox = searchBox(INGREDIENTSBOXES, ingredient.innerText);
                    ingredient.appendChild(myBox);
                    myBox.classList.remove('hidden');
                });

                ingredient.addEventListener('mouseout', () => {
                    ingredient.removeChild(ingredient.lastChild);
                });

            });
        }


        //============= TAGS FUNCRTIONALITY =============
        const tagButtons = document.querySelectorAll('.js-option-tag');
        

        tagButtons.forEach(( btn ) => {
            btn.addEventListener('click', function() {
                let tag = this.getAttribute('data-tag');
                let products = document.querySelectorAll(`.product.on-tap-drinks`);
                tagButtons.forEach(( btn ) => { btn.classList.remove('is-active') });
                
                products.forEach(( product ) => {
                    product.classList.add('hidden');

                    if(product.dataset.tag === tag) {
                        product.classList.remove('hidden');
                        btn.classList.add('is-active');
                    }
                });
            });
        });

        // tagButtons[0].click();

    }



    //END MENUS FUNCTIONALITY


    // SLIDER TITLES REPLACE
    function replaceWithSpan(text) {
        const parts = text.split('|');
        if (parts.length > 1) {
            let newText = '<span>' + parts[0] + '</span>';
            for (let i = 1; i < parts.length; i++) {
                newText += '<span>' + parts[i] + '</span>';
                
            }
            newText += '<div class="shadow"></div> <div class="shadow-big"></div>';
            return newText;
        } else {
            return text;
        }
    }
    
    

    if(document.querySelector('.slider-block')) {
        let titlesCollection = document.querySelectorAll('.slider-block .slide-title');

        titlesCollection.forEach(( title ) => {
            let titleText = title.innerText;
            titleText = replaceWithSpan( titleText );
            console.log(titleText);

            title.innerHTML = titleText;
        });
    }
    // END SLIDER TITLES REPLACE



    // UPDATE NUMBER INPUT VALUE
    if(document.querySelector('.form-module-wrapper')) {
        console.log('hay inputs tipo tex');
        let form = document.querySelector('.form-module-wrapper');
        let inputCollection = form.querySelectorAll('input[type="number"]');

        inputCollection.forEach(( input ) => {
            input.addEventListener('change', function() {
                let value = this.value;
            });
        });
    }
    // END UPDATE NUMBER INPUT VALUE

    function getParams( url ){
        let params = url.split('?')[1];
        let paramsArray = params.split('&');
        let paramsObject = {
            key: paramsArray[0].split('=')[0],
            value: paramsArray[0].split('=')[1]
        };
        return paramsObject;
    }

    function hasUrLParams( url ) {
        return url.indexOf('?') !== -1;
    }

    function scrollToElement(element) {
        window.scrollTo({
          behavior: "smooth",
          top: element.offsetTop - 150
        });
      }

    if(hasUrLParams( window.location.href )) {
        let { value } = getParams( window.location.href );

        if(document.querySelector(`.js-category[data-category="${value}"]`)){
            let targetQuad = document.querySelector(`.menus-block`); //CAMBIAR AQUI
            let targetMenu = document.querySelector(`.js-category[data-category="${value}"]`);//CAMBIAR AQUI

            scrollToElement( targetQuad );
            targetMenu.click();
        }
    }
})();